import { Subject, Subscription } from 'rxjs';
import Cookies from 'js-cookie';

export const httpStatusSubject = new Subject<number>();

const SUCCESS = 0;
let prevFetchTime: number | null = null;

export async function baseFetch<T>(input: RequestInfo, init?: RequestInit, newVersion?: boolean): Promise<T> {
  const currentTime = new Date().valueOf();
  prevFetchTime = currentTime;
  // 新版本的POST请求新增时间戳
  if (init?.method === 'POST' && newVersion) {
    const headers = new Headers(init?.headers);
    if (headers && headers.has('Content-Type') && headers.get('Content-Type') === 'multipart/form-data') {
      const formBody = init?.body as FormData;
      formBody.append('timestamp', String(currentTime));
      init.body = formBody;
    } else {
      const initBody = JSON.parse((init?.body ?? '{}') as string);
      init.body = JSON.stringify({ timestamp: currentTime, ...initBody });
    }
  }

  const compoundInit: RequestInit = {
    credentials: 'include',
    ...init,
  };

  const token = Cookies.get('token');

  if (compoundInit.headers instanceof Headers) {
    if (!compoundInit.headers.has('Accept')) {
      compoundInit.headers.set('Accept', 'application/json');
    }
    if (!compoundInit.headers.has('Content-Type') && init?.body) {
      compoundInit.headers.set('Content-Type', 'application/json;charset=UTF-8');
    }
    if (
      compoundInit.headers.has('Content-Type') &&
      compoundInit.headers.get('Content-Type') === 'multipart/form-data'
    ) {
      compoundInit.headers.delete('Content-Type');
    }
    if (!compoundInit.headers.has('satoken')) {
      if (token) {
        compoundInit.headers.set('satoken', token);
      }
    }
  } else {
    const defaultHeaders: { [key: string]: string } = {
      Accept: 'application/json',
    };
    const compoundHeaders = new Headers(compoundInit.headers);

    if (token) {
      defaultHeaders['satoken'] = token;
      defaultHeaders['Maxtropy-Token'] = `Bearer ${token}`;
    }

    if (init?.body) {
      if (compoundHeaders && compoundHeaders.get('Content-Type') === 'multipart/form-data') {
        compoundHeaders.delete('Content-Type');
      } else {
        defaultHeaders['Content-Type'] = 'application/json;charset=UTF-8';
      }
    }

    compoundInit.headers = {
      ...defaultHeaders,
      ...Object.fromEntries(compoundHeaders.entries()),
    };
  }

  const response = await window.fetch(input, compoundInit);
  httpStatusSubject.next(response.status);
  const text = await response.text();
  let body: any = undefined;
  if (text && !newVersion) {
    body = JSON.parse(text);
  }
  if (text && newVersion) {
    let res = JSON.parse(text);
    if (res?.code === SUCCESS) {
      body = res?.data;
    } else {
      throw new BusinessCodeError(res?.code ?? response.status, res?.msg ?? res?.message, body);
    }
  }
  // TODO：如果新接口没有按照规范格式返回错误，会出现错误提示不明确，后面执行一段时间将此处逻辑提到上方
  if (!response.ok) {
    throw new ResponseCodeError(response.status, body?.errorType, body?.errorMessage, body);
  }
  return body;
}

export class BusinessCodeError extends Error {
  readonly status: number;
  readonly errorMessage?: string;
  readonly body?: any;

  constructor(code: number, errorMessage?: string, body?: any) {
    super();
    this.status = code;
    this.errorMessage = errorMessage;
    this.body = body;
  }

  static getMessage(err: any): string | undefined;
  static getMessage(err: any, defaultMessage: string): string;
  static getMessage(err: any, defaultMessage?: string): string | undefined {
    return (err instanceof BusinessCodeError && err.errorMessage) || defaultMessage;
  }
}

export class ResponseCodeError extends Error {
  readonly status: number;
  readonly errorType?: string;
  readonly errorMessage?: string;
  readonly body?: any;

  constructor(status: number, errorType?: string, errorMessage?: string, body?: any) {
    super();
    this.status = status;
    this.errorType = errorType;
    this.errorMessage = errorMessage;
    this.body = body;
  }

  static getMessage(err: any): string | undefined;
  static getMessage(err: any, defaultMessage: string): string;
  static getMessage(err: any, defaultMessage?: string): string | undefined {
    return (err instanceof ResponseCodeError && err.errorMessage) || defaultMessage;
  }
}

export function observeHttpStatus(listener: (status: number) => void): Subscription {
  return httpStatusSubject.subscribe(listener);
}
